import React, { useState } from 'react';
import { Text, View, Title } from '@constants/Themed';
import DefaultScreen from '@components/Global/DefaultScreenView';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import * as Animatable from 'react-native-animatable';
import { FlatList, RefreshControl, ActivityIndicator, Animated, Pressable } from 'react-native';
import { AntDesign } from '@expo/vector-icons';
import styles from '@stylesheet';
import { useNavigation } from '@react-navigation/native';


const CreativeTemplates = () => {
  const isCompany = true;
  const [emailTemplates, setEmailTemplates] = useState([]);
  const isLoading = false;
  const refreshing = false;
  const handleModalState = () => { };
  const onRefresh = () => { };
  const [myTemplatesOpen, setMyTemplatesOpen] = useState(false);
  const theme = themeSelector();
  const navigation = useNavigation();

  const _renderItem = ({ item, index }) => {
    const renderLeftActions = (dragX) => {
      const trans = dragX.interpolate({
        inputRange: [0, 50, 100, 101],
        outputRange: [-20, 0, 0, 1],
      });
      return (
        <Animated.View
          style={[
            {
              left: 3
            },
            {
              transform: [{ translateX: trans }],
            },
          ]}>
          <View style={{ zIndex: index * -1, left: 30, flexDirection: 'column', minHeight: '90%', alignSelf: 'stretch', justifyContent: 'center', borderTopLeftRadius: 20, borderBottomLeftRadius: 20, overflow: 'hidden', top: 6 }}>
            <Pressable onPress={() => handleModalState(item)} style={[styles.centerEverything, { flex: 1, padding: 20 }]}>
              <AntDesign name="delete" size={15} color="white" style={{ flex: 1, verticalAlign: 'middle', textAlign: 'center' }} />
            </Pressable>
            <Pressable style={{ flex: 1, padding: 20, backgroundColor: '#603FEF' }}>
              <AntDesign name="share-alt" size={15} color="white" style={{ flex: 1, verticalAlign: 'middle', textAlign: 'center' }} />
            </Pressable>
          </View>
        </Animated.View>
      );
    }
  }

  return (
    <DefaultScreen
    backButton
    searchBar={{
      placeHolder: "Search Templates",
      callback: () => { },
      customIcons: [{
        function: () => {
          navigation.navigate('NewCreativeTemplate')
         },
        functionName: 'newCreative',
        icon: <AntDesign name="addfile" size={18} color={"white"} />
      }]
    }}
      containerStyle={{ paddingTop: 60 }}
    >
      <View style={{ zIndex: -1, marginTop: 20, marginRight: 40, flex: 1, padding: 20, flexDirection: 'column', alignSelf: "stretch" }}>
        {
          isCompany &&
          <Animatable.View transition={['flex', 'opacity']} style={{ flex: myTemplatesOpen ? 0.5 : 4, opacity: myTemplatesOpen ? 0.1 : 1, maxHeight: 400 }}>
            <Title style={{ borderBottomWidth: 1, borderColor: theme ? "#00000030" : "#ffffff30", marginVertical: 2 }}>Global Creatives</Title>
            {/* <FlatList style={{ marginVertical: 10 }} data={emailTemplates?.filter(item => item?.global) || []} centerContent ListEmptyComponent={(<View><Text style={{ color: theme ? "black" : "white", fontSize: 18 }}>Add templates that will be available throughout your company so members can make customised templates</Text></View>)} renderItem={({ item, index }) => <CompanyEmailItem ref={previewRef} item={item} index={index} />} horizontal contentContainerStyle={{ gap: 50 }} refreshControl={< RefreshControl refreshing={refreshing} onRefresh={() => { onRefresh() }} />} /> */}
          </Animatable.View>
        }
        {
          isLoading ?
            <View style={{ flex: 1, justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
              <ActivityIndicator size="large" color="white" />
            </View>
            :
            <View style={{ flex: myTemplatesOpen ? 8 : 4 }}>
              <View style={{ flex: 1, justifyContent: "space-between", flexDirection: "row", minHeight: 60, maxHeight: 60, borderBottomWidth: 1, borderColor: theme ? "#00000030" : "#ffffff30", marginVertical: 2 }}>
                <Title >Your Creatives</Title>
                <View style={{ flexDirection: "row", gap: 20 }}>
                  <AntDesign name={"filter"} size={24} color={theme ? "black" : "white"} style={styles.centerEverything} />
                  <AntDesign name={myTemplatesOpen ? "caret-down" : "caret-up"} size={24} color="rgb(90,192,234)" style={styles.centerEverything} onPress={() => setMyTemplatesOpen(!myTemplatesOpen)} />
                </View>
              </View>
              <FlatList indicatorStyle={theme ? 'default' : 'black'} style={{ marginVertical: 10 }} data={emailTemplates} contentContainerStyle={{ gap: 20 }} renderItem={_renderItem} refreshControl={< RefreshControl refreshing={refreshing} onRefresh={() => { onRefresh() }} />} />
            </View>
        }
      </View>
    </DefaultScreen>
  )
}
export default CreativeTemplates;